import { receiveData, receiveError } from '../api/http'
import CloudFlyerAPI from '../api/CloudFlyerAPI'

export const FETCH_API_KEY_SUCCESS = 'FETCH_API_KEY_SUCCESS'
export const FETCH_API_KEY_ERROR   = 'FETCH_API_KEY_ERROR'

export function fetchApiKey() {
  return (dispatch, getState) => {
    CloudFlyerAPI
      .user_account
      .fetchApi()
      .then(({ data }) => {
        dispatch(receiveData(FETCH_API_KEY_SUCCESS, data))
      })
      .catch(err => {
        dispatch(receiveError(FETCH_API_KEY_ERROR, err))
      })
  }
}
